import { isDarkMode } from "./darkMode";

export const highchartsOptionsBaseColor = () => {
  return {
    backgroundColor: isDarkMode() ? "var(--color-gray-800)" : "var(--color-pageBoxBackgroundLight)",
  };
};

export const highchartsOptionsAreaColor = () => {
  return {
    fillColor: {
      linearGradient: { x1: 0, y1: 0, x2: 0, y2: 1 },
      stops: [
        { 0: 0, 1: isDarkMode() ? "var(--color-gray-950)" : "var(--color-blueHighcharts)" },
        { 0: 1, 1: isDarkMode() ? "var(--color-gray-500)" : "white" },
      ],
    },
    lineWidth: 1,
    color: isDarkMode() ? "var(--color-gray-500)" : "var(--color-blueHighcharts)",
  };
};

export const highchartsOptionsRangeButtonThemeColor = () => {
  return {
    buttonTheme: {
      fill: "none",
      style: {
        color: isDarkMode() ? "white" : "var(--color-defaultText)",
        fontWeight: "bold",
        outline: "1px",
      },
      states: {
        hover: {
          fill: "#f0f8ff",
          style: { color: "#02304b" },
        },
        select: {
          fill: isDarkMode() ? "#02304b" : "#02304b",
          style: {
            color: "white",
          },
        },
      },
    },
  };
};

export const highchartsOptionsStyleColor = () => {
  return { color: isDarkMode() ? "var(--color-greyLight)" : "#02304b" };
};
